/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { REGISTER_PLACEHOLDER } from '@assetaccountant/core/http-token.interceptor';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { ClassificationSummaryDto } from '../models/classification-summary.dto';
import { ClassificationValueDto } from '../models/classification-value.dto';
import { OperationResponse } from '../models/generic/operation-response';
import { ConnectMicrosoftDynamicsCommand } from '../models/integrations/connect-microsoft-dynamics.command';
import { ConnectMicrosoftDynamicsResponse } from '../models/integrations/connect-microsoft-dynamics.response';
import { ConnectQuickBooksCommand } from '../models/integrations/connect-quick-books.command';
import { ConnectQuickBooksResponse } from '../models/integrations/connect-quick-books.response';
import { ConnectSageV2Command } from '../models/integrations/connect-sage-v2.command';
import { ConnectSageV2Response } from '../models/integrations/connect-sage-v2.response';
import { ConnectSageCommand } from '../models/integrations/connect-sage.command';
import { ConnectSageResponse } from '../models/integrations/connect-sage.response';
import { ConnectXeroCommand } from '../models/integrations/connect-xero.command';
import { ConnectXeroResponse } from '../models/integrations/connect-xero.response';
import { CreateIntegrationJournalCommand } from '../models/integrations/create-integration-journal.command';
import { CreateIntegrationJournalResponse } from '../models/integrations/create-integration-journal.response';
import { DisconnectIntegrationsCommand } from '../models/integrations/disconnect-integrations.command';
import { DisconnectIntegrationsResponse } from '../models/integrations/disconnect-integrations.response';
import { ListClassificationMappingsResponse } from '../models/integrations/list-classification-mappings.response';
import { ListDraftAssetsQuery } from '../models/integrations/list-draft-assets.query';
import { ListDraftAssetsResponse } from '../models/integrations/list-draft-assets.response';
import { ListIntegrationAccountsQuery } from '../models/integrations/list-integration-accounts.query';
import { ListIntegrationAccountsResponse } from '../models/integrations/list-integration-accounts.response';
import { ListIntegrationClassificationValuesQuery } from '../models/integrations/list-integration-classification-values.query';
import { ListIntegrationClassificationsOnlyQuery } from '../models/integrations/list-integration-classifications-only.query';
import { ListIntegrationClassificationsResponse } from '../models/integrations/list-integration-classifications.response';
import { ListMicrosoftDynamicsCompaniesQuery } from '../models/integrations/list-microsoft-dynamics-companies.query';
import { ListMicrosoftDynamicsCompaniesResponse } from '../models/integrations/list-microsoft-dynamics-companies.response';
import { ListMicrosoftDynamicsEnvironmentsQuery } from '../models/integrations/list-microsoft-dynamics-environments.query';
import { ListMicrosoftDynamicsEnvironmentsResponse } from '../models/integrations/list-microsoft-dynamics-environments.response';
import { ListRegisterIntegrationsQuery } from '../models/integrations/list-register-integrations.query';
import { ListRegisterIntegrationsResponse } from '../models/integrations/list-register-integrations.response';
import { ListSageEntitiesQuery } from '../models/integrations/list-sage-entities.query';
import { ListSageEntitiesResponse } from '../models/integrations/list-sage-entities.response';
import { ListSageJournalsResponse } from '../models/integrations/list-sage-journals.response';
import { ListSageV2EntitiesResponse } from '../models/integrations/list-sage-v2-entities.response';
import { ListSageV2JournalsResponse } from '../models/integrations/list-sage-v2-journals.response';
import { ListXeroTenantsQuery } from '../models/integrations/list-xero-tenants.query';
import { ListXeroTenantsResponse } from '../models/integrations/list-xero-tenants.response';
import { SetSageRegisterJournalCommand } from '../models/integrations/set-sage-register-journal.command';
import { SetSageRegisterJournalResponse } from '../models/integrations/set-sage-register-journal.response';
import { SetSageV2EntityCommand } from '../models/integrations/set-sage-v2-entity.command';
import { SetSageV2EntityResponse } from '../models/integrations/set-sage-v2-entity.response';
import { SetSageV2JournalEntryStateCommand } from '../models/integrations/set-sage-v2-journal-entry-state.command';
import { SetSageV2JournalEntryStateResponse } from '../models/integrations/set-sage-v2-journal-entry-state.response';
import { SetSageV2RegisterJournalCommand } from '../models/integrations/set-sage-v2-register-journal.command';
import { SetSageV2RegisterJournalResponse } from '../models/integrations/set-sage-v2-register-journal.response';
import { SyncClassificationMappingsCommand } from '../models/integrations/sync-classification-mappings.command';
import { SyncClassificationMappingsResponse } from '../models/integrations/sync-classification-mappings.response';

@Injectable({
  providedIn: 'root',
})
export class RegisterIntegrationApi {
  constructor(private http: HttpClient) {}

  connectDynamics(
    command: ConnectMicrosoftDynamicsCommand,
  ): Observable<ConnectMicrosoftDynamicsResponse> {
    return this.http.post<ConnectMicrosoftDynamicsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/microsoftDynamics`,
      command,
    );
  }

  connectQuickBooks(command: ConnectQuickBooksCommand): Observable<ConnectQuickBooksResponse> {
    return this.http.post<ConnectQuickBooksResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/quickBooks`,
      command,
    );
  }

  connectSageIntacct(command: ConnectSageCommand): Observable<ConnectSageResponse> {
    return this.http.post<ConnectSageResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/sageIntacct`,
      command,
    );
  }

  connectSageIntacctV2(command: ConnectSageV2Command): Observable<ConnectSageV2Response> {
    return this.http.post<ConnectSageV2Response>(
      `${environment.servicesApiUrl}/api/v2/integrations/sageIntacctV2`,
      command,
    );
  }

  connectXero(command: ConnectXeroCommand): Observable<ConnectXeroResponse> {
    return this.http.post<ConnectXeroResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/xero`,
      command,
    );
  }

  createJournal(
    command: CreateIntegrationJournalCommand,
  ): Observable<CreateIntegrationJournalResponse> {
    return this.http.post<CreateIntegrationJournalResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${command.integrationId}/journals`,
      command,
    );
  }

  disconnectIntegration(integrationId: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.servicesApiUrl}/api/v2/integrations/${integrationId}`,
    );
  }

  disconnectIntegrations(
    command: DisconnectIntegrationsCommand = {},
  ): Observable<DisconnectIntegrationsResponse> {
    return this.http.delete<DisconnectIntegrationsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations`,
      {
        params: {
          ...(command.tenantId ? { tenantId: command.tenantId } : {}),
          ...(command.integrationType ? { integrationType: command.integrationType } : {}),
        },
      },
    );
  }

  getAccountsLastSync(integrationId: string): Observable<OperationResponse<string>> {
    return this.http.get<OperationResponse<string>>(
      `${environment.servicesApiUrl}/api/v2/integrations/${integrationId}/accounts-last-sync`,
    );
  }

  getConnectInstructions(): Observable<OperationResponse<{}>> {
    return this.http.get<OperationResponse<{}>>(
      `${environment.servicesApiUrl}/api/v2/integrations/xero/connect`,
    );
  }

  listAccounts(query: ListIntegrationAccountsQuery): Observable<ListIntegrationAccountsResponse> {
    return this.http.get<ListIntegrationAccountsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${query.integrationId}/accounts`,
      { params: { ...(query.forceResync ? { forceResync: query.forceResync } : {}) } },
    );
  }

  listClassificationMappings(
    integrationId: string,
  ): Observable<ListClassificationMappingsResponse> {
    return this.http.get<ListClassificationMappingsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${integrationId}/classificationMappings`,
    );
  }

  listClassificationOnly(
    query: ListIntegrationClassificationsOnlyQuery,
  ): Observable<OperationResponse<ClassificationSummaryDto[]>> {
    return this.http.get<OperationResponse<ClassificationSummaryDto[]>>(
      `${environment.servicesApiUrl}/api/v2/integrations/${query.registerId ?? REGISTER_PLACEHOLDER}/${query.integrationId}/classifications`,
    );
  }

  listClassifications(integrationId: string): Observable<ListIntegrationClassificationsResponse> {
    return this.http.get<ListIntegrationClassificationsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${integrationId}/classifications`,
    );
  }

  listClassificationValues(
    query: ListIntegrationClassificationValuesQuery,
  ): Observable<OperationResponse<ClassificationValueDto[]>> {
    return this.http.get<OperationResponse<ClassificationValueDto[]>>(
      `${environment.servicesApiUrl}/api/v2/integrations/${query.registerId ?? REGISTER_PLACEHOLDER}/${query.integrationId}/classification-values/${query.classificationKey}`,
    );
  }

  listDraftAssets(query: ListDraftAssetsQuery): Observable<ListDraftAssetsResponse> {
    return this.http.get<ListDraftAssetsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${query.integrationId}/draftAssets`,
      {
        params: {
          ...(query.page ? { page: query.page } : {}),
          ...(query.simpleSearch ? { simpleSearch: query.simpleSearch } : {}),
          ...(query.dateFrom ? { dateFrom: query.dateFrom } : {}),
          ...(query.dateTo ? { dateTo: query.dateTo } : {}),
          ...(query.integrationClassificationIds
            ? Object.fromEntries(
                Object.entries(query.integrationClassificationIds).map(([key, value]) => [
                  `integrationClassificationIds[${key}]`,
                  value,
                ]),
              )
            : {}),
        },
      },
    );
  }

  listDynamicsCompanies(
    query: ListMicrosoftDynamicsCompaniesQuery = {},
  ): Observable<ListMicrosoftDynamicsCompaniesResponse> {
    return this.http.get<ListMicrosoftDynamicsCompaniesResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/microsoftDynamics/companies`,
      {
        params: {
          ...(query.tenantId ? { tenantId: query.tenantId } : {}),
          ...(query.environment ? { environment: query.environment } : {}),
        },
      },
    );
  }

  listDynamicsEnvironments(
    query: ListMicrosoftDynamicsEnvironmentsQuery = {},
  ): Observable<ListMicrosoftDynamicsEnvironmentsResponse> {
    return this.http.get<ListMicrosoftDynamicsEnvironmentsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/microsoftDynamics/environments`,
      {
        params: {
          ...(query.authorizationCode ? { authorizationCode: query.authorizationCode } : {}),
        },
      },
    );
  }

  listRegisterIntegrations(
    query: ListRegisterIntegrationsQuery = {},
  ): Observable<ListRegisterIntegrationsResponse> {
    return this.http.get<ListRegisterIntegrationsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations`,
      {
        params: {
          ...(query.tenantId ? { tenantId: query.tenantId } : {}),
          ...(query.integrationType ? { integrationType: query.integrationType } : {}),
        },
      },
    );
  }

  listSageEntities(query: ListSageEntitiesQuery): Observable<ListSageEntitiesResponse> {
    return this.http.post<ListSageEntitiesResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/sageIntacct/entities`,
      query,
    );
  }

  listSageJournals(integrationId: string): Observable<ListSageJournalsResponse> {
    return this.http.get<ListSageJournalsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${integrationId}/sageIntacct/journals`,
    );
  }

  listSageV2Entities(integrationId: string): Observable<ListSageV2EntitiesResponse> {
    return this.http.get<ListSageV2EntitiesResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${integrationId}/sageIntacctV2/entities`,
    );
  }

  listSageV2Journals(integrationId: string): Observable<ListSageV2JournalsResponse> {
    return this.http.get<ListSageV2JournalsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${integrationId}/sageIntacctV2/journals`,
    );
  }

  listXeroTenants(query: ListXeroTenantsQuery = {}): Observable<ListXeroTenantsResponse> {
    return this.http.get<ListXeroTenantsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/xero/tenants`,
      {
        params: {
          ...(query.authorizationCode ? { authorizationCode: query.authorizationCode } : {}),
        },
      },
    );
  }

  setSageJournal(
    command: SetSageRegisterJournalCommand,
  ): Observable<SetSageRegisterJournalResponse> {
    return this.http.post<SetSageRegisterJournalResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${command.integrationId}/sageIntacct/journals`,
      command,
    );
  }

  setSageV2Entity(command: SetSageV2EntityCommand): Observable<SetSageV2EntityResponse> {
    return this.http.post<SetSageV2EntityResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${command.integrationId}/sageIntacctV2/entities`,
      command,
    );
  }

  setSageV2Journal(
    command: SetSageV2RegisterJournalCommand,
  ): Observable<SetSageV2RegisterJournalResponse> {
    return this.http.post<SetSageV2RegisterJournalResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${command.integrationId}/sageIntacctV2/journals`,
      command,
    );
  }

  setSageV2JournalEntryState(
    command: SetSageV2JournalEntryStateCommand,
  ): Observable<SetSageV2JournalEntryStateResponse> {
    return this.http.post<SetSageV2JournalEntryStateResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${command.integrationId}/sageIntacctV2/journalEntries`,
      command,
    );
  }

  syncClassificationMappings(
    command: SyncClassificationMappingsCommand,
  ): Observable<SyncClassificationMappingsResponse> {
    return this.http.post<SyncClassificationMappingsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${command.integrationId}/classificationMappings`,
      command,
    );
  }
}
